import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

export type VesselQuestionnaireAction = 'upload' | 'history' | 'onboarded';

export interface VesselQuestionnairePopupData {
  showOnboardedOption?: boolean;
}

interface VesselQuestionnaireOption {
  action: VesselQuestionnaireAction;
  icon: string;
  iconClass: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-vessel-questionnaire-popup',
  templateUrl: './vessel-questionnaire-popup.component.html',
  styleUrls: ['./vessel-questionnaire-popup.component.scss'],
})
export class VesselQuestionnairePopupComponent {
  readonly options: VesselQuestionnaireOption[] = [
    {
      action: 'upload',
      icon: 'cloud_upload',
      iconClass: 'vq-popup__option-icon--upload',
      title: 'Upload Vessel Questionnaire',
      description: 'Upload a new vessel Q88 file.',
    },
    {
      action: 'history',
      icon: 'description',
      iconClass: 'vq-popup__option-icon--history',
      title: 'Questionnaire History',
      description: 'View uploaded questionnaires.',
    },
    {
      action: 'onboarded',
      icon: 'directions_boat',
      iconClass: 'vq-popup__option-icon--vessel',
      title: 'View Onboarded Vessels',
      description: 'Browse onboarded vessels.',
    },
  ];

  constructor(
    private requestFormService: RequestFormService,
    private dialogRef: MatDialogRef<VesselQuestionnairePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VesselQuestionnairePopupData,
  ) {}

  get visibleOptions(): VesselQuestionnaireOption[] {
    if (this.data?.showOnboardedOption === false) {
      return this.options.filter((option) => option.action !== 'onboarded');
    }
    return this.options;
  }

  close(): void {
    this.dialogRef.close();
  }

  isDarkMode(): boolean {
    return this.requestFormService.isDarkMode();
  }

  select(action: VesselQuestionnaireAction): void {
    this.dialogRef.close(action);
  }
}
